const updateQuicksight = {
  toastr: 'Updated User',
  toastr1:' has been updated successfully',
  toastrError: 'Answer already registered',
  toastrError1: 'Enter another name'
};

export default updateQuicksight;
